var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('review-list',{attrs:{"service_providers_id":_vm.serviceProvidersIds[0],"isMainHeader":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }